import axios from "axios";
import { API } from "../API";
import { isAutheticated } from "../components/auth/authhelper";

const callApi = async (url, data = null, method = "GET") => {
  const { token } = isAutheticated()
  try {
    const response = await axios({
      url,
      data: (data),
      method,
      headers: {
        "Access-Control-Allow-Origin": "*",
        // Authorization: `Bearer ${localStorage.getItem("id_token")}`,
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log(response);
    return response.data;
  } catch (err) {
    console.log(err);
    return err;
  }
};
const Api = {
  getBanners: (username) =>
    callApi(`${API}/banners/${username}`),
  getLatest: () =>
    callApi(`${API}/latest/`),
  getTranding: () =>
    callApi(`${API}/movies/`),
  getContinueToWatch: () =>
    callApi(`${API}/api/client/view_continue`),
  getMovieInfo: (username, videoid) =>
    callApi(`${API}/movie/${username}/${videoid}`),

  AddToWatchlist: (videoid) =>
    callApi(`${API}/api/watchlist/add_watchlist/${videoid}`, {}, "POST")
  ,
  RemoveFromWatchlist: (videoid) =>
    callApi(`${API}/api/watchlist/remove_watchlist/${videoid}`, {}, "DELETE")
  ,
  getWatchList: () =>
    callApi(`${API}/api/watchlist/viewWatchlist`),

  getTvShowsBanners: (username) =>
    callApi(`${API}/tvshow/${username}`),
  getTvShowsLatest: (username) =>
    callApi(`${API}/latestTvShows/${username}`),
  getTrendingTvShows: (username) =>
    callApi(`${API}/trendingTvShows/${username}`),
  getTvShowInfo: (username, showid) =>
    callApi(`${API}/tvshow/${username}/${showid}`),

  getUserAbout: (username) =>
    callApi(`${API}/profile/${username}`),
  getUserAddress: (username) =>
    callApi(`${API}/address/${username}`),
  getClient: (username) =>
    callApi(`${API}/api/client`),
  updateClient: (email, firstName, lastName) =>
    callApi(`${API}/api/client`, { email, firstName, lastName }, "PATCH"),

  getConfigText: (username) =>
    callApi(`${API}/api/client/configText/${username}`),



  postMovieInfo: (data) =>
    callApi(`${API}/api/client/resumeplay`, data, "POST"),

  SignIn: (data) =>
    callApi(`${API}/api/user/login`, data, "POST"),
  SignUp: (data) =>
    callApi(`${API}/api/user/register`, data, "POST"),

  geyPaymentDetails: (data) =>
    callApi(`${API}/api/client/stripe/check-checkout-session`, data, "POST"),

  getSearchItems: (name) =>
    callApi(`${API}/search_tvshow/channel.r/${name}`),
  getStudioInfo: (videoId) => {
    callApi(`${API}/api/studio/${videoId}/get_studio`)
  },
  postOrder: (username, productId, CTA) =>
    callApi(`${API}/api/client/salesLeads`, { username, productId, CTA }, "POST"),
  //view product
  ViewProduct: () =>
    callApi(`${API}/api/product`),
  addToCart: (username, productId, req_quantity) =>
    callApi(`${API}/api/cart/add_product`, { username, productId, req_quantity }, "POST"),
  getCart: () =>
    callApi(`${API}/api/cart/view_cart`),
  cartQuantity: (productId, req_quantity) =>
    callApi(`${API}/api/cart/update_quantity/${productId}`, { req_quantity }, "PATCH"),
  cartRemove: (productId, req_quantity) =>
    callApi(`${API}/api/cart/remove_product/${productId}`, {}, "DELETE"),

  addAddress: (body) =>
    callApi(`${API}/api/address/add_address`, body, "POST"),
  getAddresses: () =>
    callApi(`${API}/api/address/view_address`),
  getAddress: (id) =>
    callApi(`${API}/api/address/view_addressID/${id}`),
  updateAddress: (id, body) =>
    callApi(`${API}/api/address/update_address/${id}`, body, "PATCH"),
  deleteAddress: (id,) =>
    callApi(`${API}/api/address/remove_address/${id}`, {}, "DELETE"),

};

export default Api;
